import styled from "styled-components";

export const Button = styled.div<{show: boolean}>`
  display: ${({show}) => show ? 'flex' : 'none'};
  align-items: center;
  position: fixed;
  border-radius: 40px;
  bottom: 50px;
  right: 10px;
  z-index: 1000;
  scroll-behavior: smooth;
  width: 60px;
  height: 60px;
  background: ${({theme}) => theme.colors.scrollTopButtonBackground};
  cursor: pointer;

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    border-radius: 40px;
    padding: 2px; 
    background: ${({theme}) => theme.colors.scrollTopButtonBackgroundBorder};
    -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask-composite: exclude;
    pointer-events: none;
  }
  
  & svg {
    transform: rotate(180deg);
    opacity: 0.8;
  }
  
  &:hover {
    background: ${({theme}) => theme.colors.scrollTopButtonBackgroundHover};
    & svg {
      opacity: 1;
    }
  }
`